
const LigneFactureLibreCollection = function(element) {
    this.element = $(element);
    this.tbody = this.element.find('table tbody');
    this.tfoot   = this.element.find('table tfoot');

    this.element.on('click', '[data-add-line]', () => {
        const tr = this.initRow();
        this.updateRow(tr);
    });

    this.tbody.on('click', '[data-delete]', event => {
        $(event.currentTarget).closest('tr').remove();
    });

    /// Mise à jour donnée dans le tableau
    this.tbody.on('keyup change', 'input, select', event => {
        this.updateTotalRow($(event.currentTarget).closest('tr'));
    });
}

$.extend(LigneFactureLibreCollection.prototype, {
    initRow: function() {
        let prototype = this.element.attr('data-prototype'),
            name = 0;

        // Find max name
        this.element.find('[data-name]').each(function() {
            let n = parseInt($(this).attr('data-name'));

            if (n >= name) {
                name = n + 1;
            }
        });

        prototype = prototype.replace(/__name__/g, name);

        return $(prototype).appendTo(this.tbody);
    },

    updateRow: function(row) {
        // row.find('[name$="\[tauxTVA\]"]').val(20);

        this.updateTotalRow(row);
    },

    updateTotalRow: function(row) {
        let quantiteUnitaire = row.find('[name$="\[quantiteUnitaire\]"]').parseFloat(),
            prixUnitaire = row.find('[name$="\[prixUnitaire\]"]').parseMoney();
        let totalHT = prixUnitaire * quantiteUnitaire;

        let remise = (row.find('[name$="\[remise\]"]').parseFloat() / 100.) || 0.;
        totalHT *= (1. - remise);

        let tauxTVA = row.find('[name$="\[tauxTVA\]"]').parseFloat();

        let totalTTC = totalHT * (1.0 + tauxTVA);

        row.find('[name$="\[totalHT\]"]').formatMoney(totalHT);
        row.find('[name$="\[totalTTC\]"]').formatMoney(totalTTC);

        // Refresh quantite KGS if line is KGS
        if (row.attr('data-ligne-kgs') === '1') {
            row.find('[name$="\[quantite\]"]').formatFloat(quantiteUnitaire);
            row.find('[name$="\[prix\]"]').val(prixUnitaire);
        }

        this.updateTotalFooter();
    },

    updateTotalFooter: function() {
        let totalHT = 0, totalTTC = 0;

        this.tbody.find('tr').each(function() {
            const $tr = $(this);

            totalHT  += $tr.find('[name$="\[totalHT\]"]').parseMoney();
            totalTTC += $tr.find('[name$="\[totalTTC\]"]').parseMoney();
        });

        this.tfoot.find('[data-total-ht]').formatMoney(totalHT);
        this.tfoot.find('[data-total-tva]').formatMoney(totalTTC - totalHT);
        this.tfoot.find('[data-total-ttc]').formatMoney(totalTTC);
    },

});

const ligneFactureLibreCollection = () => {
    $(document).arrive('[data-ligne-facture-libre-collection]', {
        existing: true
    }, function() {
        new LigneFactureLibreCollection(this);
    });
};

export { ligneFactureLibreCollection }


// WEBPACK FOOTER //
// ./js/form/ligneFactureLibreCollection.js